
import config from '../config.json';

const konsole = {
    log:(...args)=>{
        if (config.OPEN_CONSOLE) {
            console.log(...args);
        }
    },
    error:(...args)=>{
        if (config.OPEN_CONSOLE) {
            console.error(...args);
        }
    },
    decor:(...args)=>{
        if (config.OPEN_CONSOLE) {
            console.log('-*-*-*-',...args,'-*-*-*-');
        }
    },
    encapse:(...args)=>{
        if (config.OPEN_CONSOLE) {
            console.log('-*-*-*-*-*-*--*-*-*-*-*-*--*-*-*-*-*-*-');
            console.log(...args);
            console.log('-*-*-*-*-*-*--*-*-*-*-*-*--*-*-*-*-*-*-');
        }
    }
}

export default konsole;